import React from 'react';
import {Link} from '@reach/router';

import {Pill} from 'ui-kit';

import * as styles from './MembersList.module.css';

const formatDate = new Intl.DateTimeFormat().format;

export function MembersList({empty, members}) {
  if (empty) {
    return (
      <div className={styles.EmptyContainer}>
        <p className={styles.EmptyText}>You do not have any memberships yet.</p>
        <Link to="/memberships/new">Create a membership</Link>
      </div>
    );
  }

  if (members.length === 0) {
    return (
      <div className={styles.EmptyContainer}>
        <p className={styles.EmptyText}>
          No matching members for your current filters.
        </p>
      </div>
    );
  }

  return (
    <ul className={styles.Container}>
      {members.map(member => {
        const {
          id,
          firstName,
          lastName,
          membershipV2,
          subscriptionStatus,
          activeSubscription,
        } = member;

        const endDate =
          activeSubscription == null ? null : activeSubscription.endDate;

        return (
          <li className={styles.ItemContainer} key={id}>
            <Link
              to={`/memberships/${membershipV2.id}`}
              className={styles.Item}
            >
              <p>
                <strong>
                  {firstName} {lastName}
                </strong>
              </p>
              {subscriptionStatus === 'ACTIVE' ? (
                <Pill color="green">
                  Active until {formatDate(new Date(endDate))}
                </Pill>
              ) : subscriptionStatus === 'EXPIRED' ? (
                <Pill color="red">Expired</Pill>
              ) : subscriptionStatus == null ? (
                <Pill>No subscription</Pill>
              ) : null}
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
